import React, {useContext, useEffect, useState} from 'react';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from '@material-ui/core/styles';
import AppContext from '../../Services/AppContext';
import PersistantData from '../../Services/PersistantData';
import Button from '@material-ui/core/Button';
import {useCommonStyles} from '../../Styles';
import {
    ck_u_password,
    ck_u_username,
    defDateFormat,
    empty,
    req_cust,
    req_cust_area,
    req_cust_category,
    req_cust_chain,
    req_cust_type,
    req_report_oos_insight,
    req_report_oos_insight_graph,
    req_report_oosreport,
    req_report_oos_insight_report,
    req_salesman,
    req_stock,
    req_stock_category,
    req_stock_brand,
    req_settings_branches
} from '../../Helper/Constants';
import _ from 'lodash';
import API_Service, {axiosDefaultConfig, axiosURIencode} from '../../Services/API_Service';
import {useSnackbar} from 'notistack';
import KeyboardArrowDownRoundedIcon from '@material-ui/icons/KeyboardArrowDownRounded';
import moment from 'moment';
import VirtualListCB from '../../Components/VirtualListCB';
import format from 'date-fns/format';
import useCookieHook from "../../Services/useCookieHook";
import { Paper, Table, TableBody, TableCell, TableContainer, TableRow, TableHead, Tooltip, IconButton, CircularProgress, TextField, InputAdornment, Grid, Chip, Box } from '@material-ui/core';
import {Assessment as AssessmentIcon, PictureAsPdf as PictureAsPdfIcon, Visibility as VisibilityIcon, VisibilityOff as VisibilityOffIcon} from '@material-ui/icons';
import { grey, orange, red } from '@material-ui/core/colors';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import InsertInvitationIcon from '@material-ui/icons/InsertInvitation';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip as ChartTooltip,
    Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Line } from 'react-chartjs-2';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    ChartTooltip,
    Legend,
    ChartDataLabels
);

const useStyles = makeStyles((theme) => ({
    viewInRow: {
		display: 'flex',
		flexWrap: 'wrap',
		alignItems: 'left',
		marginTop: theme.spacing(1),
		rowGap: 10
	},
	container: {
        maxHeight: '78vh',
        maxWidth: '92vw',
    },
    boldText: {
        fontWeight: 'bold',
    },
    tableHeadRow: {
        backgroundColor: '#1a1a1a',
		fontSize: 11,
		padding: '8px 12px',
		margin: 0,
        color: '#ffffff',
        fontWeight: 600,
        borderBottom: '2px solid #333333',
        textAlign: 'center',
        whiteSpace: 'nowrap',
        minWidth: '80px'
    },
    tableHeadRowFirst: {
        backgroundColor: '#1a1a1a',
		fontSize: 11,
		padding: '8px 12px',
		margin: 0,
        color: '#ffffff',
        fontWeight: 600,
        borderBottom: '2px solid #333333',
        textAlign: 'left',
        whiteSpace: 'nowrap',
        minWidth: '120px'
    },
	tableCellAutoWidth: {
		whiteSpace: "nowrap", 
		overflow: "hidden",
		fontSize: 11,
		padding: '6px 12px',
		margin: 0,
        borderBottom: '1px solid #2a2a2a',
        backgroundColor: '#1e1e1e',
        color: '#e0e0e0',
        textAlign: 'center'
	},
    tableCellAutoWidth2: {
		whiteSpace: "nowrap", 
		overflow: "hidden",
		fontSize: 11,
		padding: '6px 12px',
		margin: 0,
        borderBottom: '1px solid #2a2a2a',
        backgroundColor: '#1e1e1e',
        color: '#e0e0e0',
        textAlign: 'left'
	},
	table : {
		fontSize: 11,
		borderCollapse: 'collapse',
        backgroundColor: '#1a1a1a',
        border: '1px solid #333333'
	},
	customDatePicker: {
		"& .MuiOutlinedInput-root" : {
			height: "100%",
		},
		"& .MuiOutlinedInput-root .MuiOutlinedInput-input": {
			padding: "5px 15px",
			fontSize: 12,
			textAlign: "center",
		},
		width: 300,
		marginRight: 10,
		fontSize: 12,
	},
    sectionTitle: {
        fontSize: 16,
        fontWeight: 600,
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(1),
        color: '#ffffff',
        backgroundColor: '#2a2a2a',
        padding: '8px 16px',
        borderRadius: 4,
        borderLeft: '4px solid #4caf50'
    },
    tableSection: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(3),
        backgroundColor: '#1a1a1a',
        border: '1px solid #333333',
        borderRadius: 4,
        overflow: 'hidden',
        boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
        width: '93vw',
        maxWidth: '93vw',
        position: 'relative',
        // 添加滚动提示图标
        // '&::before': {
        //     content: '"⟷"',
        //     position: 'absolute',
        //     bottom: '8px',
        //     right: '16px',
        //     color: '#666666',
        //     fontSize: '14px',
        //     fontWeight: 'bold',
        //     backgroundColor: 'rgba(26,26,26,0.9)',
        //     padding: '2px 6px',
        //     borderRadius: '3px',
        //     border: '1px solid #333333',
        //     zIndex: 2,
        //     opacity: 0.7,
        //     transition: 'opacity 0.3s ease',
        //     pointerEvents: 'none'
        // },
        // '&:hover::before': {
        //     opacity: 1
        // }
    },
    tableScrollContainer: {
        overflowX: 'auto',
        width: '100%',
        maxWidth: '93vw',
        scrollBehavior: 'smooth',
        // 自定义滚动条样式
        '&::-webkit-scrollbar': {
            height: '8px',
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: '#2a2a2a',
            borderRadius: '4px',
            margin: '0 4px',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#555555',
            borderRadius: '4px',
            border: '1px solid #333333',
            transition: 'background-color 0.2s ease',
            '&:hover': {
                backgroundColor: '#666666',
            },
            '&:active': {
                backgroundColor: '#777777',
            }
        },
        '&::-webkit-scrollbar-corner': {
            backgroundColor: '#2a2a2a',
        },
        // Firefox滚动条样式
        scrollbarWidth: 'thin',
        scrollbarColor: '#555555 #2a2a2a'
    },
    frozenTable: {
        display: 'table',
        borderCollapse: 'separate',
        borderSpacing: 0,
        width: 'max-content',
        minWidth: '100%'
    },
    frozenTableHead: {
        position: 'sticky',
        top: 0,
        zIndex: 10,
        backgroundColor: '#1a1a1a'
    },
    frozenHeaderCell: {
        position: 'sticky',
        backgroundColor: '#1a1a1a',
        zIndex: 5,
        '&:nth-child(1)': {
            left: 0,
            zIndex: 6
        },
        '&:nth-child(2)': {
            left: '120px',
            zIndex: 6
        },
        '&:nth-child(3)': {
            left: '200px',
            zIndex: 6
        },
        '&:nth-child(4)': {
            left: '280px',
            zIndex: 6
        }
    },
    frozenBodyCell: {
        position: 'sticky',
        backgroundColor: 'inherit',
        zIndex: 3,
        '&:nth-child(1)': {
            left: 0,
            zIndex: 4,
            backgroundColor: 'inherit'
        },
        '&:nth-child(2)': {
            left: '120px',
            zIndex: 4,
            backgroundColor: 'inherit'
        },
        '&:nth-child(3)': {
            left: '200px',
            zIndex: 4,
            backgroundColor: 'inherit'
        },
        '&:nth-child(4)': {
            left: '280px',
            zIndex: 4,
            backgroundColor: 'inherit'
        }
    },
    chartContainer: {
        backgroundColor: '#1a1a1a',
        border: '1px solid #333333',
        borderRadius: 4,
        padding: '20px',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(3),
        boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
        width: '93vw',
        maxWidth: '93vw'
    },
    fixedWidthContainer: {
        width: '93vw',
        maxWidth: '93vw',
        marginBottom: theme.spacing(3)
    },
    tablesContainer: {
        width: '93vw',
        maxWidth: '93vw'
    },
    productSelector: {
        marginBottom: theme.spacing(2),
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        flexWrap: 'wrap'
    },
    productChip: {
        backgroundColor: '#333333',
        color: '#ffffff',
        '&:hover': {
            backgroundColor: '#444444'
        }
    }
}));

export default function OOSInsight() {
    const commonStyle = useCommonStyles();
	const classes = useStyles();

	const singleton = PersistantData.getInstance();
	const [gState, setGState] = useContext(AppContext);
	var {translation: language, client} = gState;
	if (typeof (language) === 'undefined') {
		language = singleton.getlang()
	}

	const [cookies, setCookie] = useCookieHook([ck_u_username, ck_u_password]);
	const {enqueueSnackbar, closeSnackbar} = useSnackbar();

    // Data states
    const [oosDataTableHeader1, setOosDataTableHeader1] = useState([]);
    const [oosDataTableHeader2, setOosDataTableHeader2] = useState([]);
    const [oosDataTableHeader3, setOosDataTableHeader3] = useState([]);
    const [oosDataTable1, setOosDataTable1] = useState([]);
    const [oosDataTable2, setOosDataTable2] = useState([]);
    const [oosDataTable3, setOosDataTable3] = useState([]);

    // Filter lists
    const [branchesList, setBranchesList] = useState([]);
    const [itemCategoryList, setItemCategoryList] = useState([]);
    const [itemList, setItemList] = useState([]);
    const [outletCategoryList, setOutletCategoryList] = useState([]);
    const [outletChainList, setOutletChainList] = useState([]);
    const [outletTypeList, setOutletTypeList] = useState([]);

    // Filter views
    const [branchesView, setBranchesView] = useState(false);
    const [itemCategoryView, setItemCategoryView] = useState(false);
    const [itemView, setItemView] = useState(false);
    const [outletCategoryView, setOutletCategoryView] = useState(false);
    const [outletChainView, setOutletChainView] = useState(false);
    const [outletTypeView, setOutletTypeView] = useState(false);

    // Selected values
    const [selectedBranch, setSelectedBranch] = useState(empty);
    const [selectedBranchValue, setSelectedBranchValue] = useState(empty);
    const [selectedItemCategory, setSelectedItemCategory] = useState(empty);
    const [selectedItemCategoryValue, setSelectedItemCategoryValue] = useState(empty);
    const [selectedItem, setSelectedItem] = useState(empty);
    const [selectedItemValue, setSelectedItemValue] = useState(empty);
    const [selectedOutletCategory, setSelectedOutletCategory] = useState(empty);
    const [selectedOutletCategoryValue, setSelectedOutletCategoryValue] = useState(empty);
    const [selectedOutletChain, setSelectedOutletChain] = useState(empty);
    const [selectedOutletChainValue, setSelectedOutletChainValue] = useState(empty);
    const [selectedOutletType, setSelectedOutletType] = useState(empty);
    const [selectedOutletTypeValue, setSelectedOutletTypeValue] = useState(empty);

    // Date ranges
    const [monthDateRange, setMonthDateRange] = useState({});
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    
    // 设置默认月份范围：一年前的下个月到当前月份
    const getDefaultDateRange = () => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth();
        
        // 一年前的下个月
        // const startDate = new Date(currentYear - 1, currentMonth + 1, 1);
        // 最近5个月
        const startDate = new Date(currentYear, currentMonth - 5, 1);
        // 当前月份
        const endDate = new Date(currentYear, currentMonth, 1);
        
        return { startDate, endDate };
    };
    
    const defaultRange = getDefaultDateRange();
    const [graphStartMonth, setGraphStartMonth] = useState(defaultRange.startDate);
    const [graphEndMonth, setGraphEndMonth] = useState(defaultRange.endDate);
    const [loading, setLoading] = useState(false);

    // Chart data states
    const [chartData, setChartData] = useState({});
    const [availableProducts, setAvailableProducts] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);

    useEffect(() => {
		if (gState.client) {
			loadBranches(gState.client);
            loadItemCategories(gState.client);
            loadItems(gState.client);
            loadOutletCategories(gState.client);
            loadOutletChains(gState.client);
            loadOutletTypes(gState.client);
		}
	}, [gState.client, gState.translation]);

    const snack = (msg, type = 'success') => {
		enqueueSnackbar(msg, {
			variant: type,
			preventDuplicate: true,
			autoHideDuration: type === 'success' ? 2000 : 3000
		});
	}

    // Load filter data functions
    const loadBranches = (_client = client) => {
		API_Service.get(req_settings_branches, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData} = data;
			if (result) {
				setBranchesList(extraData);
			}
		}).catch(err => console.error('Error loading branches:', err));
	}

    const loadItemCategories = (_client = client) => {
		API_Service.get(req_stock_category, axiosDefaultConfig(_client)).then(({data}) => {
			if (!_.isEmpty(data)) {
				var _arr = [];
				for (let idx = 0; idx < data.length; idx++) {
					const {category_id, categoryIdentifierId, category_name, category_status} = data[idx];
					if (parseInt(category_status) === 1) {
						_arr.push({
							name: category_name,
							secondary: categoryIdentifierId,
							value: category_id,
							status: 1
						});
					} else {
						_arr.push({
							name: category_name,
							secondary: categoryIdentifierId,
							value: category_id,
							status: 0
						});
					}
				}
				setItemCategoryList(_arr);
			}
		}).catch(err => console.error('Error loading item categories:', err));
	}

    const loadItems = (_client = client) => {
		var req = `${req_stock}-1`;
		API_Service.get(req, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData} = data;
			const {stock: stockApi} = extraData;
			if (result) {
				var _data = [];
				for (let idx = 0; idx < stockApi.length; idx++) {
					const {product_name, product_code, product_status} = stockApi[idx];
					_data.push({name: product_name, secondary: product_code, value: product_code, status: parseInt(product_status)});
				}
				setItemList(_data);
			}
		}).catch(err => console.error('Error loading items:', err));
	}

    const loadOutletCategories = (_client = client) => {
		API_Service.get(req_cust_category, axiosDefaultConfig(_client)).then(({data}) => {
			if (data) {
				var {result, extraData } = data;
				if (parseInt(result) === 1) {
					var _arr = [];
					for (let i = 0; i < extraData.length; i++) {
						const {cust_category_id, cust_category_code, cust_category_name, cust_category_status} = extraData[i];
						if (parseInt(cust_category_status) === 1) {
							_arr.push({
								name: cust_category_name,
								secondary: cust_category_code,
								value: cust_category_id,
								status: 1
							});
						} else {
							_arr.push({
								name: cust_category_name,
								secondary: cust_category_code,
								value: cust_category_id,
								status: 0
							});
						}
					}
					setOutletCategoryList(_arr);
				}
			}
		}).catch(err => console.error('Error loading outlet categories:', err));
	}

    const loadOutletChains = (_client = client) => {
		API_Service.get(req_cust_chain, axiosDefaultConfig(_client)).then(({data}) => {
			if (data) {
				var {result, extraData } = data;
				if (parseInt(result) === 1) {
					var _arr = [];
					for (let i = 0; i < extraData.length; i++) {
						const {cust_chain_id, cust_chain_code, cust_chain_name, cust_chain_status} = extraData[i];
						if (parseInt(cust_chain_status) === 1) {
							_arr.push({
								name: cust_chain_name,
								secondary: cust_chain_code,
								value: cust_chain_id,
								status: 1
							});
						}else{
							_arr.push({
								name: cust_chain_name,
								secondary: cust_chain_code,
								value: cust_chain_id,
								status: 0
							});
						}
					}
					setOutletChainList(_arr);
				}
			}
		}).catch(err => console.error('Error loading outlet chains:', err));
	}

    const loadOutletTypes = (_client = client) => {
		API_Service.get(req_cust_type, axiosDefaultConfig(_client)).then(({data}) => {
			if (data) {
				var {result, extraData } = data;
				if (parseInt(result) === 1) {
					var _arr = [];
					for (let i = 0; i < extraData.length; i++) {
						const {name, code, id, status} = extraData[i];
						if (parseInt(status) === 1) {
							_arr.push({
								name: name,
								secondary: code,
								value: id,
								status: 1
							});
						}else{
							_arr.push({
								name: name,
								secondary: code,
								value: id,
								status: 0
							});
						}
					}
					setOutletTypeList(_arr);
				}
			}
		}).catch(err => console.error('Error loading outlet types:', err));
	}

    // Filter close functions
    const BranchesViewClose = (newValue) => {
		setBranchesView(false);
		if (newValue) {
			var value = '';
			var name = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					value += newValue[i].value;
					name += newValue[i].name;
				} else {
					value += newValue[i].value + ",";
					name += newValue[i].name + ",";
				}
			}
			setSelectedBranchValue(value);
			setSelectedBranch(name);
		}
	}

    const ItemCategoryViewClose = (newValue) => {
		setItemCategoryView(false);
		if (newValue) {
			var value = '';
			var name = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					value += newValue[i].value;
					name += newValue[i].name;
				} else {
					value += newValue[i].value + ",";
					name += newValue[i].name + ",";
				}
			}
			setSelectedItemCategoryValue(value);
			setSelectedItemCategory(name);
		}
	}

    const ItemViewClose = (newValue) => {
		setItemView(false);
		if (newValue) {
			var value = '';
			var name = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					value += newValue[i].value;
					name += newValue[i].name;
				} else {
					value += newValue[i].value + ",";
					name += newValue[i].name + ",";
				}
			}
			setSelectedItemValue(value);
			setSelectedItem(name);
		}
	}

    const OutletCategoryViewClose = (newValue) => {
		setOutletCategoryView(false);
		if (newValue) {
			var value = '';
			var name = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					value += newValue[i].value;
					name += newValue[i].name;
				} else {
					value += newValue[i].value + ",";
					name += newValue[i].name + ",";
				}
			}
			setSelectedOutletCategoryValue(value);
			setSelectedOutletCategory(name);
		}
	}

    const OutletChainViewClose = (newValue) => {
		setOutletChainView(false);
		if (newValue) {
			var value = '';
			var name = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					value += newValue[i].value;
					name += newValue[i].name;
				} else {
					value += newValue[i].value + ",";
					name += newValue[i].name + ",";
				}
			}
			setSelectedOutletChainValue(value);
			setSelectedOutletChain(name);
		}
	}

    const OutletTypeViewClose = (newValue) => {
		setOutletTypeView(false);
		if (newValue) {
			var value = '';
			var name = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					value += newValue[i].value;
					name += newValue[i].name;
				} else {
					value += newValue[i].value + ",";
					name += newValue[i].name + ",";
				}
			}
			setSelectedOutletTypeValue(value);
			setSelectedOutletType(name);
		}
	}

    // Get OOS data
    const getOOSData = (_client = client) => {
		setLoading(true);
		var st_date = '';
		var st_date_to = '';
		if (!_.isEmpty(monthDateRange)) {
			st_date = format(monthDateRange.startDate, defDateFormat);
			st_date_to = format(monthDateRange.endDate, defDateFormat);
		}
		
        var parameters = {
			client: client,
			date_from: st_date,
			date_to: st_date_to,
			branch: selectedBranchValue,
			item_category: selectedItemCategoryValue,
			item: selectedItemValue,
			outlet_category: selectedOutletCategoryValue,
			outlet_chain: selectedOutletChainValue,
			outlet_type: selectedOutletTypeValue,
			username: cookies(ck_u_username),
		};

		if (gState.company) {
			parameters.company = gState.company;
		}

		const param = axiosURIencode(parameters);
		API_Service.get(`${req_report_oos_insight}?${param}`, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData} = data;
			if (result) {
                // Assuming the API returns three different tables of data
                const {outlet_category_header, outlet_category_array, outlet_chain_header, outlet_chain_array, outlet_type_header, outlet_type_array} = extraData;
                setOosDataTableHeader1(outlet_category_header || []);
                setOosDataTableHeader2(outlet_chain_header || []);
                setOosDataTableHeader3(outlet_type_header || []);
				setOosDataTable1(outlet_category_array || []);
                setOosDataTable2(outlet_chain_array || []);
                setOosDataTable3(outlet_type_array || []);
			} else {
				setOosDataTable1([]);
                setOosDataTable2([]);
                setOosDataTable3([]);
				snack(language.no_data || 'No data found', 'warning');
			}
			setLoading(false);
		}).catch(err => {
            console.error('Error fetching OOS data:', err);
            setLoading(false);
            snack('Error fetching data', 'error');
        });
	}

    const getOOSGraphData = (_client = client) => {
        setLoading(true);
        var start_month = '';
        var end_month = '';
        if (graphStartMonth) {
            start_month = format(graphStartMonth, 'yyyy-MM');
        }
        if (graphEndMonth) {
            end_month = format(graphEndMonth, 'yyyy-MM');
        }
        
        var parameters = {
            client: client,
            start_month: start_month,
            end_month: end_month,
            branch: selectedBranchValue,
            item_category: selectedItemCategoryValue,
            item: selectedItemValue,
            outlet_category: selectedOutletCategoryValue,
            outlet_chain: selectedOutletChainValue,
            outlet_type: selectedOutletTypeValue,
            username: cookies(ck_u_username),
        };

        if (gState.company) {
            parameters.company = gState.company;
        }

        const param = axiosURIencode(parameters);
        API_Service.get(`${req_report_oos_insight_graph}?${param}`, axiosDefaultConfig(_client)).then(({data}) => {
            const {result, extraData} = data;
            if (result) {
                processChartData(extraData);
                snack('Graph data loaded', 'success');
            } else {
                snack(language.no_data || 'No data found', 'warning');
            }
            setLoading(false);
        }).catch(err => {
            console.error('Error fetching graph data:', err);
            setLoading(false);
            snack('Failed to fetch graph data', 'error');
        });
    }

    // Process chart data
    const processChartData = (extraData) => {
        if (!extraData || !extraData.product_month_data) {
            return;
        }

        const productData = extraData.product_month_data;
        const products = Object.keys(productData);
        setAvailableProducts(products);
        setSelectedProducts(products); // Initially select all products

        // Get all months from the data
        const months = Object.keys(productData[products[0]] || {});
        
        // Format months from "2025-01" to "Jan 2025"
        const formattedMonths = months.map(month => {
            const [year, monthNum] = month.split('-');
            const monthName = new Date(year, monthNum - 1).toLocaleString('en-US', { month: 'short' });
            return `${monthName} ${year}`;
        });

        // Generate colors for products
        const colors = generateProductColors(products.length);

        // Create datasets for chart
        const datasets = products.map((product, index) => ({
            label: product,
            data: months.map(month => productData[product][month] || 0),
            borderColor: colors[index],
            backgroundColor: colors[index],
            tension: 0,
            pointRadius: 4,
            pointHoverRadius: 6,
            hidden: false
        }));

        setChartData({
            labels: formattedMonths,
            datasets: datasets
        });
    }

    // Generate colors for products
    const generateProductColors = (count) => {
        const colors = [
            "#FF6F00", "#1A237E", "#388E3C", "#8E24AA", "#F44336",
            "#0097A7", "#9C27B0", "#0D47A1", "#4DD0E1", "#E53935",
            "#7CB342", "#AB47BC", "#FF8F00", "#26C6DA", "#00695C",
            "#BA68C8", "#689F38", "#D84315", "#1565C0", "#FFB300",
            "#6A1B9A", "#2E7D32", "#BF360C", "#3F51B5", "#00ACC1",
            "#FF5722", "#C62828", "#FFA000", "#1B5E20", "#7B1FA2",
            "#FFCA28", "#8BC34A", "#B71C1C", "#303F9F", "#FF7043",
            "#3949AB", "#F57C00", "#1976D2", "#AD1457", "#43A047",
            "#512DA8", "#00796B", "#F06292", "#0288D1", "#CDDC39",
            "#E91E63", "#009688", "#7E57C2", "#C2185B", "#00BCD4"
          ];
        
        while (colors.length < count) {
            let randomColor;
            let attempts = 0;
            
            do {
                // Generate RGB values in range (30-180) to avoid black/dark and too bright colors
                const r = Math.floor(Math.random() * 151) + 30;
                const g = Math.floor(Math.random() * 151) + 30;
                const b = Math.floor(Math.random() * 151) + 30;
                
                // Calculate the difference between max and min RGB values to avoid gray colors
                const maxRgb = Math.max(r, g, b);
                const minRgb = Math.min(r, g, b);
                const rgbDifference = maxRgb - minRgb;
                
                // Calculate brightness to avoid too dark colors
                const brightness = (r * 0.299 + g * 0.587 + b * 0.114);
                
                // Only accept colors that:
                // 1. Have sufficient difference between RGB values (not gray)
                // 2. Have adequate brightness (not too dark)
                // 3. Are not too close to black or gray
                if (rgbDifference >= 40 && brightness >= 60 && (r + g + b) >= 150) {
                    randomColor = `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
                    break;
                }
                
                attempts++;
            } while (attempts < 50); // Prevent infinite loop
            
            // If we couldn't generate a good color, use a fallback
            if (attempts >= 50) {
                const fallbackColors = ['#FF6B35', '#F7931E', '#FFD23F', '#EE4B2B', '#4CBB17', '#6495ED', '#FF69B4', '#32CD32'];
                randomColor = fallbackColors[colors.length % fallbackColors.length];
            }
            
            colors.push(randomColor);
        }
        
        return colors;
    }

    // Toggle individual product selection
    const toggleProductSelection = (product) => {
        if (selectedProducts.includes(product)) {
            setSelectedProducts(selectedProducts.filter(p => p !== product));
        } else {
            setSelectedProducts([...selectedProducts, product]);
        }
    }

    // Show all products
    const showAllProducts = () => {
        setSelectedProducts(availableProducts);
    }

    // Hide all products
    const hideAllProducts = () => {
        setSelectedProducts([]);
    }

    // Update chart visibility based on selected products
    const getFilteredChartData = () => {
        if (!chartData.datasets) return chartData;

        const filteredDatasets = chartData.datasets.map(dataset => ({
            ...dataset,
            hidden: !selectedProducts.includes(dataset.label)
        }));

        return {
            ...chartData,
            datasets: filteredDatasets
        };
    }

    // Export chart as PDF
    const exportChartAsPDF = async () => {
        const chartElement = document.getElementById('complete-chart-container');
        if (!chartElement) {
            snack('Chart container not found', 'error');
            return;
        }

        // Get the chart canvas element directly
        const chartCanvas = chartElement.querySelector('canvas');
        if (!chartCanvas) {
            snack('Chart canvas not found', 'error');
            return;
        }

        setLoading(true);

        try {
            // 等待字体加载完成 (防止线上环境字体还没应用就截图模糊)
            if (document.fonts && document.fonts.ready) {
                await document.fonts.ready;
            }

            // 获取设备像素比
            const dpr = window.devicePixelRatio || 1;

            // Create PDF in landscape orientation
            const pdf = new jsPDF('landscape', 'mm', 'a4');
            const pageWidth = 297; // A4 landscape width
            const pageHeight = 210; // A4 landscape height
            
            // Set margins
            const margin = 5; // 5mm margins
            const availableWidth = pageWidth - (margin * 2);
            const availableHeight = pageHeight - (margin * 2);

            // ===== 第一页：图表 =====
            // 创建图表容器
            const chartContainer = document.createElement('div');
            chartContainer.style.backgroundColor = '#1a1a1a';
            chartContainer.style.padding = '15px';
            chartContainer.style.width = '1400px';
            chartContainer.style.fontFamily = 'Arial, sans-serif';
            chartContainer.style.borderRadius = '8px';
            chartContainer.style.boxSizing = 'border-box';

            // 图表标题
            const chartTitle = document.createElement('div');
            chartTitle.textContent = `Product Out of Stock Linear Graph (${format(graphStartMonth, 'MMM yyyy')} - ${format(graphEndMonth, 'MMM yyyy')})`;
            chartTitle.style.color = '#ffffff';
            chartTitle.style.fontSize = '20px';
            chartTitle.style.fontWeight = 'bold';
            chartTitle.style.marginBottom = '15px';
            chartTitle.style.textAlign = 'center';
            chartContainer.appendChild(chartTitle);

            // 创建产品图例/标签部分
            if (chartData.datasets && chartData.datasets.length > 0) {
                const legendContainer = document.createElement('div');
                legendContainer.style.marginBottom = '20px';
                legendContainer.style.padding = '12px';
                legendContainer.style.backgroundColor = '#2a2a2a';
                legendContainer.style.borderRadius = '6px';
                legendContainer.style.border = '1px solid #333333';

                const legendTitle = document.createElement('div');
                legendTitle.textContent = 'Products:';
                legendTitle.style.color = '#ffffff';
                legendTitle.style.fontSize = '14px';
                legendTitle.style.fontWeight = 'bold';
                legendTitle.style.marginBottom = '10px';
                legendContainer.appendChild(legendTitle);

                const tagsContainer = document.createElement('div');
                tagsContainer.style.display = 'flex';
                tagsContainer.style.flexWrap = 'wrap';
                tagsContainer.style.gap = '8px';

                chartData.datasets.forEach((dataset) => {
                    const productTag = document.createElement('div');
                    productTag.style.display = 'inline-flex';
                    productTag.style.alignItems = 'center';
                    productTag.style.backgroundColor = dataset.borderColor;
                    productTag.style.color = '#ffffff';
                    productTag.style.padding = '5px 10px';
                    productTag.style.borderRadius = '15px';
                    productTag.style.fontSize = '12px';
                    productTag.style.fontWeight = 'bold';
                    productTag.style.border = '1px solid #555555';
                    productTag.style.marginRight = '6px';
                    productTag.style.marginBottom = '5px';
                    productTag.style.whiteSpace = 'nowrap';
                    
                    // 添加颜色指示器
                    const colorDot = document.createElement('span');
                    colorDot.style.display = 'inline-block';
                    colorDot.style.width = '8px';
                    colorDot.style.height = '8px';
                    colorDot.style.backgroundColor = '#ffffff';
                    colorDot.style.borderRadius = '50%';
                    colorDot.style.marginRight = '6px';
                    productTag.appendChild(colorDot);
                    
                    productTag.appendChild(document.createTextNode(dataset.label));
                    tagsContainer.appendChild(productTag);
                });

                legendContainer.appendChild(tagsContainer);
                chartContainer.appendChild(legendContainer);
            }

            // 创建专门用于PDF导出的图表
            // 根据产品数量动态计算高度，避免拉伸
            const productCount = chartData.datasets ? chartData.datasets.length : 0;
            const baseHeight = 400; // 基础高度
            const heightPerProduct = Math.max(8, Math.min(20, 120 / Math.max(productCount, 1))); // 每个产品增加的高度，最小8px，最大20px
            const dynamicHeight = Math.max(baseHeight, baseHeight + (productCount * heightPerProduct));
            const finalHeight = Math.min(dynamicHeight, 700); // 最大高度限制为700px
            
            const pdfChartContainer = document.createElement('div');
            pdfChartContainer.style.width = '1370px';
            pdfChartContainer.style.height = finalHeight + 'px';
            pdfChartContainer.style.backgroundColor = '#1a1a1a';
            pdfChartContainer.style.position = 'relative';
            pdfChartContainer.style.borderRadius = '6px';
            pdfChartContainer.style.overflow = 'hidden';
            pdfChartContainer.style.border = '1px solid #333333';

            const pdfCanvas = document.createElement('canvas');
            pdfCanvas.width = 1370;
            pdfCanvas.height = finalHeight;
            pdfCanvas.style.width = '1370px';
            pdfCanvas.style.height = finalHeight + 'px';
            pdfChartContainer.appendChild(pdfCanvas);

            // PDF专用图表配置
            const pdfChartOptions = {
                responsive: false,
                maintainAspectRatio: false,
                animation: false,
                interaction: {
                    mode: 'index',
                    intersect: false,
                },
                plugins: {
                    title: {
                        display: false
                    },
                    legend: {
                        display: false
                    },
                    tooltip: {
                        enabled: false // 禁用PDF的工具提示
                    },
                    datalabels: {
                        display: false, // Disabled percentage display on chart
                        // align: 'top',
                        // anchor: 'end',
                        // offset: 8,
                        // color: '#ffffff',
                        // backgroundColor: function(context) {
                        //     return context.dataset.borderColor;
                        // },
                        // borderColor: '#333333',
                        // borderWidth: 1,
                        // borderRadius: 4,
                        // padding: {
                        //     top: 4,
                        //     bottom: 4,
                        //     left: 8,
                        //     right: 8
                        // },
                        // font: {
                        //     size: 14,
                        //     weight: 'bold',
                        //     family: 'Arial'
                        // },
                        // formatter: function(value, context) {
                        //     return value.toFixed(2) + '%';
                        // }
                    }
                },
                scales: {
                    x: {
                        display: true,
                        title: {
                            display: true,
                            text: 'Month',
                            color: '#ffffff',
                            font: {
                                size: 18,
                                weight: 'bold',
                                family: 'Arial'
                            },
                            padding: {top: 10, bottom: 10}
                        },
                        ticks: {
                            color: '#bbbbbb',
                            font: {
                                size: 16,
                                family: 'Arial'
                            },
                            padding: 8
                        },
                        grid: {
                            color: '#333333'
                        }
                    },
                    y: {
                        display: true,
                        title: {
                            display: true,
                            text: 'OOS Percentage (%)',
                            color: '#ffffff',
                            font: {
                                size: 18,
                                weight: 'bold',
                                family: 'Arial'
                            },
                            padding: {top: 0, bottom: 10}
                        },
                        ticks: {
                            color: '#bbbbbb',
                            font: {
                                size: 16,
                                family: 'Arial'
                            },
                            padding: 8,
                            callback: function(value) {
                                return value.toFixed(1) + '%';
                            }
                        },
                        grid: {
                            color: '#333333'
                        }
                    }
                },
                elements: {
                    point: {
                        radius: 7,
                        hoverRadius: 9,
                        borderWidth: 2
                    },
                    line: {
                        tension: 0.3, // 使线条更平滑
                        borderWidth: 3 // 增加线条宽度
                    }
                }
            };

            // 创建PDF专用图表
            const pdfChart = new ChartJS(pdfCanvas.getContext('2d'), {
                type: 'line',
                data: getFilteredChartData(),
                options: pdfChartOptions,
                plugins: [ChartDataLabels]
            });

            // 等待图表渲染
            await new Promise(resolve => setTimeout(resolve, 500));

            chartContainer.appendChild(pdfChartContainer);

            // 临时添加到DOM以进行渲染
            chartContainer.style.position = 'absolute';
            chartContainer.style.left = '-9999px';
            chartContainer.style.top = '-9999px';
            document.body.appendChild(chartContainer);

            // 等待PDF图表完全渲染
            await new Promise(resolve => setTimeout(resolve, 500));

            // 将图表转换为图像
            const chartCanvas = await html2canvas(chartContainer, {
                backgroundColor: '#1a1a1a',
                scale: 5 * dpr,   // 关键：用 DPR 放大，Windows 普屏也会更清晰
                useCORS: true,
                allowTaint: true,
                width: 1400,
                height: chartContainer.scrollHeight,
                logging: false
            });

            // 清理PDF图表实例
            pdfChart.destroy();
            
            // 移除临时元素
            document.body.removeChild(chartContainer);

            // 转换为高质量图像
            const chartImgData = chartCanvas.toDataURL('image/png', 1.0);
            
            // 计算图表在PDF中的实际尺寸，保持原始比例
            const chartAspectRatio = chartCanvas.width / chartCanvas.height;
            let pdfChartWidth = availableWidth;
            let pdfChartHeight = availableWidth / chartAspectRatio;
            
            // 如果高度超过可用高度，则按高度缩放
            if (pdfChartHeight > availableHeight) {
                pdfChartHeight = availableHeight;
                pdfChartWidth = availableHeight * chartAspectRatio;
            }
            
            // 居中显示
            const chartX = margin + (availableWidth - pdfChartWidth) / 2;
            const chartY = margin + (availableHeight - pdfChartHeight) / 2;
            
            // 添加图表到第一页，保持原始比例
            pdf.addImage(chartImgData, 'PNG', chartX, chartY, pdfChartWidth, pdfChartHeight, '', 'FAST');

            // ===== 第二页：表格 =====
            // 添加新页面
            pdf.addPage();

            // 创建表格容器
            const tableContainer = document.createElement('div');
            tableContainer.style.backgroundColor = '#1a1a1a';
            tableContainer.style.padding = '15px';
            tableContainer.style.width = '1400px';
            tableContainer.style.fontFamily = 'Arial, sans-serif';
            tableContainer.style.borderRadius = '8px';
            tableContainer.style.boxSizing = 'border-box';

            // 表格标题
            const tableTitle = document.createElement('div');
            tableTitle.textContent = `Product Out of Stock Data Table (${format(graphStartMonth, 'MMM yyyy')} - ${format(graphEndMonth, 'MMM yyyy')})`;
            tableTitle.style.color = '#ffffff';
            tableTitle.style.fontSize = '20px';
            tableTitle.style.fontWeight = 'bold';
            tableTitle.style.marginBottom = '15px';
            tableTitle.style.textAlign = 'center';
            tableContainer.appendChild(tableTitle);

            // 创建表格
            if (chartData.datasets && chartData.datasets.length > 0) {
                const tableWrapper = document.createElement('div');
                tableWrapper.style.backgroundColor = '#1a1a1a';
                tableWrapper.style.border = '1px solid #333333';
                tableWrapper.style.borderRadius = '6px';
                tableWrapper.style.overflow = 'hidden';
                tableWrapper.style.marginTop = '15px';

                const table = document.createElement('table');
                table.style.width = '100%';
                table.style.tableLayout = 'fixed';
                table.style.borderCollapse = 'collapse';
                table.style.backgroundColor = '#1a1a1a';
                table.style.fontSize = '12px'; // 增加字体大小

                // 创建表头
                const thead = document.createElement('thead');
                const headerRow = document.createElement('tr');
                headerRow.style.backgroundColor = '#2a2a2a';
                
                // 第一个表头单元格（产品）
                const productHeader = document.createElement('th');
                productHeader.textContent = 'Product';
                productHeader.style.backgroundColor = '#2a2a2a';
                productHeader.style.color = '#ffffff';
                productHeader.style.padding = '10px 8px';
                productHeader.style.textAlign = 'left';
                productHeader.style.borderBottom = '2px solid #444444';
                productHeader.style.borderRight = '1px solid #444444';
                productHeader.style.fontWeight = 'bold';
                productHeader.style.minWidth = '150px';
                headerRow.appendChild(productHeader);

                // 月份表头
                chartData.labels.forEach(month => {
                    const monthHeader = document.createElement('th');
                    monthHeader.textContent = month;
                    monthHeader.style.backgroundColor = '#2a2a2a';
                    monthHeader.style.color = '#ffffff';
                    monthHeader.style.padding = '10px 6px';
                    monthHeader.style.textAlign = 'center';
                    monthHeader.style.borderBottom = '2px solid #444444';
                    monthHeader.style.borderRight = '1px solid #444444';
                    monthHeader.style.fontWeight = 'bold';
                    monthHeader.style.minWidth = '90px';
                    monthHeader.style.whiteSpace = 'nowrap';
                    monthHeader.style.fontSize = '11px';
                    headerRow.appendChild(monthHeader);
                });

                thead.appendChild(headerRow);
                table.appendChild(thead);

                // 创建表格主体
                const tbody = document.createElement('tbody');
                
                chartData.datasets.forEach((dataset, index) => {
                    const row = document.createElement('tr');
                    row.style.backgroundColor = index % 2 === 0 ? '#1e1e1e' : '#242424';

                    // 产品名称单元格带颜色指示器
                    const productCell = document.createElement('td');
                    productCell.style.padding = '8px 8px';
                    productCell.style.borderBottom = '1px solid #333333';
                    productCell.style.borderRight = '1px solid #333333';
                    productCell.style.color = '#ffffff';
                    productCell.style.fontWeight = 'bold';
                    productCell.style.fontSize = '11px';
                    
                    // 添加颜色指示器
                    const colorIndicator = document.createElement('span');
                    colorIndicator.style.display = 'inline-block';
                    colorIndicator.style.width = '10px';
                    colorIndicator.style.height = '10px';
                    colorIndicator.style.backgroundColor = dataset.borderColor;
                    colorIndicator.style.marginRight = '8px';
                    colorIndicator.style.borderRadius = '3px';
                    colorIndicator.style.border = '1px solid #555555';
                    
                    productCell.appendChild(colorIndicator);
                    productCell.appendChild(document.createTextNode(dataset.label));
                    row.appendChild(productCell);

                    // 数据单元格
                    dataset.data.forEach(value => {
                        const dataCell = document.createElement('td');
                        dataCell.textContent = value.toFixed(2) + '%';
                        dataCell.style.padding = '8px 6px';
                        dataCell.style.textAlign = 'center';
                        dataCell.style.borderBottom = '1px solid #333333';
                        dataCell.style.borderRight = '1px solid #333333';
                        dataCell.style.color = '#e0e0e0';
                        dataCell.style.fontSize = '11px';
                        
                        // 添加基于产品颜色的微妙背景色
                        const productColor = dataset.borderColor;
                        const rgb = productColor.match(/\d+/g);
                        if (rgb && rgb.length >= 3) {
                            dataCell.style.backgroundColor = `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, 0.1)`;
                        }
                        
                        row.appendChild(dataCell);
                    });

                    tbody.appendChild(row);
                });

                table.appendChild(tbody);
                tableWrapper.appendChild(table);
                tableContainer.appendChild(tableWrapper);
            }

            // 临时添加到DOM以进行渲染
            tableContainer.style.position = 'absolute';
            tableContainer.style.left = '-9999px';
            tableContainer.style.top = '-9999px';
            document.body.appendChild(tableContainer);

            // 等待表格完全渲染
            await new Promise(resolve => setTimeout(resolve, 300));

            // 将表格转换为图像
            const tableCanvas = await html2canvas(tableContainer, {
                backgroundColor: '#1a1a1a',
                scale: 5 * dpr,
                useCORS: true,
                allowTaint: true,
                width: 1400,
                height: tableContainer.scrollHeight,
                logging: false
            });
            
            // 移除临时元素
            document.body.removeChild(tableContainer);

            // 转换为高质量图像
            const tableImgData = tableCanvas.toDataURL('image/png', 1.0);
            
            // 计算表格在PDF中的实际尺寸，保持原始比例
            const tableAspectRatio = tableCanvas.width / tableCanvas.height;
            let pdfTableWidth = availableWidth;
            let pdfTableHeight = availableWidth / tableAspectRatio;
            
            // 如果高度超过可用高度，则按高度缩放
            if (pdfTableHeight > availableHeight) {
                pdfTableHeight = availableHeight;
                pdfTableWidth = availableHeight * tableAspectRatio;
            }
            
            // 左右居中显示
            const tableX = margin + (availableWidth - pdfTableWidth) / 2;
            
            // 添加表格到第二页，保持原始比例，左右居中
            pdf.addImage(tableImgData, 'PNG', tableX, margin, pdfTableWidth, pdfTableHeight, '', 'FAST');

            // 保存PDF
            const startMonthStr = format(graphStartMonth, 'yyyy-MM');
            const endMonthStr = format(graphEndMonth, 'yyyy-MM');
            pdf.save(`OOS_Insight_Chart_${startMonthStr}_to_${endMonthStr}.pdf`);
            snack('Chart exported as PDF', 'success');

        } catch (err) {
            console.error('Error exporting chart:', err);
            snack('Failed to export chart', 'error');
        } finally {
            setLoading(false);
        }
    }

    // Generate report
    const generateReport = (_client = client) => {
        setLoading(true);
		var st_date = '';
		var st_date_to = '';
		if (!_.isEmpty(monthDateRange)) {
			st_date = format(monthDateRange.startDate, defDateFormat);
			st_date_to = format(monthDateRange.endDate, defDateFormat);
		}
		
        var parameters = {
			client: client,
			date_from: st_date,
			date_to: st_date_to,
			branch: selectedBranchValue,
			item_category: selectedItemCategoryValue,
			item: selectedItemValue,
			outlet_category: selectedOutletCategoryValue,
			outlet_chain: selectedOutletChainValue,
			outlet_type: selectedOutletTypeValue,
			username: cookies(ck_u_username),
		};

		if (gState.company) {
			parameters.company = gState.company;
		}

		const param = axiosURIencode(parameters);
		API_Service.get(`${req_report_oos_insight_report}?${param}`, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData} = data;
			if (result == 1) {
                window.open(extraData.url, '_blank');
			} else {
                snack(language.no_data || 'No data found', 'warning');
			}
			setLoading(false);
		}).catch(err => {
            console.error('Error generating report:', err);
            setLoading(false);
            snack('Error generating report', 'error');
        });
    }

    const renderTable1 = () => {
        const header = oosDataTableHeader1 || [];
        const dataTable = oosDataTable1 || [];

        return (
            <div>
                <TableContainer component={Paper} className={classes.tableSection}>
                    <div className={classes.tableScrollContainer}>
                        <Table size="small" className={`${classes.table} ${classes.frozenTable}`}>
                            <TableHead className={classes.frozenTableHead}>
                                <TableRow>
                                    {header.map((item, index) => (
                                        <TableCell 
                                            className={`${index === 0 ? classes.tableHeadRowFirst : classes.tableHeadRow} ${index < 4 ? classes.frozenHeaderCell : ''}`} 
                                            key={index}
                                        >
                                            {item}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {dataTable.map((row, index) => (
                                    <TableRow key={index} hover style={{backgroundColor: index % 2 === 0 ? '#1e1e1e' : '#242424'}}>
                                        <TableCell className={`${classes.tableCellAutoWidth2} ${classes.frozenBodyCell}`}>{row.category_name}</TableCell>
                                        <TableCell className={`${classes.tableCellAutoWidth} ${classes.frozenBodyCell}`}>{row.outlet_total}</TableCell>
                                        <TableCell className={`${classes.tableCellAutoWidth} ${classes.frozenBodyCell}`}>{row.visited_total}</TableCell>
                                        <TableCell className={`${classes.tableCellAutoWidth} ${classes.frozenBodyCell}`}>{row.visited_percentage}</TableCell>
                                        {row.product_array.map((item, itemIndex) => (
                                            <React.Fragment key={itemIndex}>
                                                <TableCell className={classes.tableCellAutoWidth}>{item.count}</TableCell>
                                                <TableCell className={classes.tableCellAutoWidth}>{item.percentage}</TableCell>
                                            </React.Fragment>
                                        ))}
                                        <TableCell className={classes.tableCellAutoWidth}>{row.total_count}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                </TableContainer>
            </div>
        );
    };

    const renderTable2 = () => {
        const header = oosDataTableHeader2 || [];
        const dataTable = oosDataTable2 || [];

        return (
            <div>
                <TableContainer component={Paper} className={classes.tableSection}>
                    <div className={classes.tableScrollContainer}>
                        <Table size="small" className={`${classes.table} ${classes.frozenTable}`}>
                            <TableHead className={classes.frozenTableHead}>
                                <TableRow>
                                    {header.map((item, index) => (
                                        <TableCell 
                                            className={`${index === 0 ? classes.tableHeadRowFirst : classes.tableHeadRow} ${index < 4 ? classes.frozenHeaderCell : ''}`} 
                                            key={index}
                                        >
                                            {item}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {dataTable.map((row, index) => (
                                    <TableRow key={index} hover style={{backgroundColor: index % 2 === 0 ? '#1e1e1e' : '#242424'}}>
                                        <TableCell className={`${classes.tableCellAutoWidth2} ${classes.frozenBodyCell}`}>{row.chain_name}</TableCell>
                                        <TableCell className={`${classes.tableCellAutoWidth} ${classes.frozenBodyCell}`}>{row.outlet_total}</TableCell>
                                        <TableCell className={`${classes.tableCellAutoWidth} ${classes.frozenBodyCell}`}>{row.visited_total}</TableCell>
                                        <TableCell className={`${classes.tableCellAutoWidth} ${classes.frozenBodyCell}`}>{row.visited_percentage}</TableCell>
                                        {row.product_array.map((item, itemIndex) => (
                                            <React.Fragment key={itemIndex}>
                                                <TableCell className={classes.tableCellAutoWidth}>{item.count}</TableCell>
                                                <TableCell className={classes.tableCellAutoWidth}>{item.percentage}</TableCell>
                                            </React.Fragment>
                                        ))}
                                        <TableCell className={classes.tableCellAutoWidth}>{row.total_count}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                </TableContainer>
            </div>
        );
    };

    const renderTable3 = () => {
        const header = oosDataTableHeader3 || [];
        const dataTable = oosDataTable3 || [];

        return (
            <div>
                <TableContainer component={Paper} className={classes.tableSection}>
                    <div className={classes.tableScrollContainer}>
                        <Table size="small" className={`${classes.table} ${classes.frozenTable}`}>
                            <TableHead className={classes.frozenTableHead}>
                                <TableRow>
                                    {header.map((item, index) => (
                                        <TableCell 
                                            className={`${index === 0 ? classes.tableHeadRowFirst : classes.tableHeadRow} ${index < 4 ? classes.frozenHeaderCell : ''}`} 
                                            key={index}
                                        >
                                            {item}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {dataTable.map((row, index) => (
                                    <TableRow key={index} hover style={{backgroundColor: index % 2 === 0 ? '#1e1e1e' : '#242424'}}>
                                        <TableCell className={`${classes.tableCellAutoWidth2} ${classes.frozenBodyCell}`}>{row.type_name}</TableCell>
                                        <TableCell className={`${classes.tableCellAutoWidth} ${classes.frozenBodyCell}`}>{row.outlet_total}</TableCell>
                                        <TableCell className={`${classes.tableCellAutoWidth} ${classes.frozenBodyCell}`}>{row.visited_total}</TableCell>
                                        <TableCell className={`${classes.tableCellAutoWidth} ${classes.frozenBodyCell}`}>{row.visited_percentage}</TableCell>
                                        {row.product_array.map((item, itemIndex) => (
                                            <React.Fragment key={itemIndex}>
                                                <TableCell className={classes.tableCellAutoWidth}>{item.count}</TableCell>
                                                <TableCell className={classes.tableCellAutoWidth}>{item.percentage}</TableCell>
                                            </React.Fragment>
                                        ))}
                                        <TableCell className={classes.tableCellAutoWidth}>{row.total_count}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                </TableContainer>
            </div>
        );
    };

    const renderGraph = () => {

        ChartTooltip.positioners.customPosition = function(items, position) {
            // 获取图表画布的宽度
            const chart = this.chart;
            const chartArea = chart.chartArea;
            const chartWidth = chartArea.right - chartArea.left;
            
            // 计算相对于图表区域的位置
            const relativeX = position.x - chartArea.left;
            const tooltipWidth = 100; // 估计的tooltip宽度
            
            // 如果数据点在图表右侧75%的区域内，向左显示tooltip
            if (relativeX > chartWidth * 0.90) {
                return {
                    x: position.x - tooltipWidth,
                    y: position.y - 40
                };
            } else {
                // 否则向右显示
                return {
                    x: position.x + 100,
                    y: position.y - 40
                };
            }
        };

        // Chart.js options with dark theme
        const chartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            interaction: {
                mode: 'index',
                intersect: false,
            },
            plugins: {
                title: {
                    display: true,
                    // text: `OOS Insight Chart - ${selectedYear}`,
                    color: '#ffffff',
                    font: {
                        size: 16,
                        weight: 'bold'
                    }
                },
                legend: {
                    display: false, // We'll use custom product selector
                    position: 'top',
                    labels: {
                        color: '#ffffff',
                        usePointStyle: true,
                        pointStyle: 'line'
                    }
                },
                tooltip: {
                    position: 'customPosition',
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    titleColor: '#ffffff',
                    bodyColor: '#ffffff',
                    borderColor: '#333333',
                    borderWidth: 1,
                    itemSort: function(a, b) {
                        return b.parsed.y - a.parsed.y;
                    },
                    callbacks: {
                        label: function(context) {
                            return `${context.dataset.label}: ${context.parsed.y.toFixed(2)}%`;
                        }
                    }
                },
                datalabels: {
                    display: false // Disable data labels for system display
                }
            },
            scales: {
                x: {
                    display: true,
                    title: {
                        display: true,
                        text: 'Month',
                        color: '#ffffff',
                        font: {
                            size: 12,
                            weight: 'bold'
                        }
                    },
                    ticks: {
                        color: '#bbbbbb'
                    },
                    grid: {
                        color: '#333333'
                    }
                },
                y: {
                    display: true,
                    title: {
                        display: true,
                        text: 'OOS Percentage (%)',
                        color: '#ffffff',
                        font: {
                            size: 12,
                            weight: 'bold'
                        }
                    },
                    ticks: {
                        color: '#bbbbbb',
                        callback: function(value) {
                            return value.toFixed(2) + '%';
                        }
                    },
                    grid: {
                        color: '#333333'
                    }
                }
            },
            elements: {
                point: {
                    radius: 4,
                    hoverRadius: 6
                }
            }
        };

        if (!chartData.datasets || chartData.datasets.length === 0) {
            return (
                <div className={classes.chartContainer}>
                    <Typography style={{ color: '#ffffff', textAlign: 'center', padding: '40px' }}>
                        No chart data available. Click "View" to load data.
                    </Typography>
                </div>
            );
        }

        return (
            <div id="complete-chart-container" className={classes.chartContainer}>
                {/* Title and Controls Header */}
                <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center', 
                    marginBottom: '16px',
                    flexWrap: 'wrap',
                    gap: '8px'
                }}>
                    <Typography variant="h6" style={{ color: '#ffffff' }}>
                        Product Out of Stock Linear Graph ({format(graphStartMonth, 'MMM yyyy')} - {format(graphEndMonth, 'MMM yyyy')})
                    </Typography>
                    
                    {/* Product Selection Controls */}
                    <div style={{ 
                        display: 'flex', 
                        gap: '8px',
                        flexWrap: 'wrap'
                    }}>
                        <Button
                            variant="outlined"
                            size="small"
                            onClick={showAllProducts}
                            startIcon={<VisibilityIcon />}
                            style={{
                                color: '#4caf50',
                                borderColor: '#4caf50'
                            }}
                        >
                            Show All
                        </Button>

                        <Button
                            variant="outlined"
                            size="small"
                            onClick={hideAllProducts}
                            startIcon={<VisibilityOffIcon />}
                            style={{
                                color: '#f44336',
                                borderColor: '#f44336'
                            }}
                        >
                            Hide All
                        </Button>
                    </div>
                </div>

                {/* Product Selection as Clickable Chips */}
                <div style={{ marginBottom: '16px' }}>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                        {availableProducts.map((product, index) => {
                            const dataset = chartData.datasets.find(d => d.label === product);
                            const isSelected = selectedProducts.includes(product);
                            return (
                                <Chip
                                    key={product}
                                    label={product}
                                    size="small"
                                    clickable
                                    onClick={() => toggleProductSelection(product)}
                                    style={{
                                        backgroundColor: isSelected ? (dataset ? dataset.borderColor : '#666666') : '#333333',
                                        color: '#ffffff',
                                        fontWeight: isSelected ? 'bold' : 'normal',
                                        opacity: isSelected ? 1 : 0.6,
                                        border: isSelected ? `2px solid ${dataset ? dataset.borderColor : '#666666'}` : '2px solid transparent'
                                    }}
                                />
                            );
                        })}
                    </div>
                </div>

                {/* Chart */}
                <div id="oos-chart" style={{ height: '400px', backgroundColor: '#1a1a1a' }}>
                    <Line data={getFilteredChartData()} options={chartOptions} />
                </div>

                {/* Chart Statistics */}
                <div style={{ marginTop: '16px', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                    <Typography variant="body2" style={{ color: '#bbbbbb' }}>
                        Total Products: {availableProducts.length}
                    </Typography>
                    <Typography variant="body2" style={{ color: '#bbbbbb' }}>
                        Visible Products: {selectedProducts.length}
                    </Typography>
                    <Typography variant="body2" style={{ color: '#bbbbbb' }}>
                        Period: {format(graphStartMonth, 'MMM yyyy')} - {format(graphEndMonth, 'MMM yyyy')}
                    </Typography>
                </div>
            </div>
        );
    };

    return (
        <div>
            {/* Fixed Width Container for Filters and Chart */}
            <div className={classes.fixedWidthContainer}>
                {/* Normal Filters - Row 1 */}
                <div style={{display: 'flex', gap: 10, marginTop: 8, marginBottom: 10}}>
                    {/* Outlet Category Filter */}
                    <Button
                        style={{flex: 1}}
                        variant="outlined"
                        onClick={() => setOutletCategoryView(true)}
                        endIcon={<KeyboardArrowDownRoundedIcon/>}>
                        <Typography className={commonStyle.searchBtnFont}>
                            {selectedOutletCategory ? _.truncate(selectedOutletCategory, {length: 20}) : "Outlet Category"}
                        </Typography>
                    </Button>

                    {/* Outlet Chain Filter */}
                    <Button
                        style={{flex: 1}}
                        variant="outlined"
                        onClick={() => setOutletChainView(true)}
                        endIcon={<KeyboardArrowDownRoundedIcon/>}>
                        <Typography className={commonStyle.searchBtnFont}>
                            {selectedOutletChain ? _.truncate(selectedOutletChain, {length: 20}) : "Outlet Chain"}
                        </Typography>
                    </Button>

                    {/* Outlet Type Filter */}
                    <Button
                        style={{flex: 1}}
                        variant="outlined"
                        onClick={() => setOutletTypeView(true)}
                        endIcon={<KeyboardArrowDownRoundedIcon/>}>
                        <Typography className={commonStyle.searchBtnFont}>
                            {selectedOutletType ? _.truncate(selectedOutletType, {length: 20}) : "Outlet Type"}
                        </Typography>
                    </Button>
                </div>

                {/* Normal Filters - Row 2 */}
                <div style={{display: 'flex', gap: 10, marginTop: 8, marginBottom: 10}}>
                    {/* Item Category Filter */}
                    <Button
                        style={{flex: 1}}
                        variant="outlined"
                        onClick={() => setItemCategoryView(true)}
                        endIcon={<KeyboardArrowDownRoundedIcon/>}>
                        <Typography className={commonStyle.searchBtnFont}>
                            {selectedItemCategory ? _.truncate(selectedItemCategory, {length: 20}) : "Item Category"}
                        </Typography>
                    </Button>

                    {/* Item Filter */}
                    <Button
                        style={{flex: 1}}
                        variant="outlined"
                        onClick={() => setItemView(true)}
                        endIcon={<KeyboardArrowDownRoundedIcon/>}>
                        <Typography className={commonStyle.searchBtnFont}>
                            {selectedItem ? _.truncate(selectedItem, {length: 20}) : "Item"}
                        </Typography>
                    </Button>

                    {/* Branch Filter */}
                    {!gState.company && branchesList.length > 0 && (
                        <Button
                            style={{flex: 1}}
                            variant="outlined"
                            onClick={() => setBranchesView(true)}
                            endIcon={<KeyboardArrowDownRoundedIcon/>}>
                            <Typography className={commonStyle.searchBtnFont}>
                                {selectedBranch ? _.truncate(selectedBranch, {length: 20}) : "Branch"}
                            </Typography>
                        </Button>
                    )}
                </div>

                {/* Month Range Filter */}
                <div className={classes.viewInRow}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <DatePicker
                            className={classes.customDatePicker}
                            inputVariant={"outlined"}
                            views={['month', 'year']}
                            label="Start Month"
                            value={graphStartMonth}
                            onChange={(date) => {
                                if (date) {
                                    setGraphStartMonth(date);
                                }
                            }}
                            renderInput={(params) => (
                                <TextField {...params} placeholder="Start Month" InputProps={{
                                    endAdornment: 
                                        <InputAdornment position="end">
                                            <InsertInvitationIcon />
                                        </InputAdornment>
                                }} />
                            )}
                        />
                        
                        <DatePicker
                            className={classes.customDatePicker}
                            inputVariant={"outlined"}
                            views={['month', 'year']}
                            label="End Month"
                            value={graphEndMonth}
                            onChange={(date) => {
                                if (date) {
                                    setGraphEndMonth(date);
                                }
                            }}
                            renderInput={(params) => (
                                <TextField {...params} placeholder="End Month" InputProps={{
                                    endAdornment: 
                                        <InputAdornment position="end">
                                            <InsertInvitationIcon />
                                        </InputAdornment>
                                }} />
                            )}
                        />
                    </MuiPickersUtilsProvider>

                    <Button
                        style={{marginRight: 10}}
                        size="small"
                        color="primary"
                        variant={'contained'}
                        onClick={() => getOOSGraphData()}
                        disabled={loading}>
                        <Typography className={commonStyle.searchBtnFont}>View</Typography>
                        {loading && <CircularProgress size={20}/>}
                    </Button>

                    <Button
                        size="small"
                        color="secondary"
                        variant={'contained'}
                        onClick={() => exportChartAsPDF()}
                        disabled={loading}>
                        <Typography className={commonStyle.searchBtnFont}>Generate Report</Typography>
                        {loading && <CircularProgress size={20}/>}
                    </Button>
                </div>

                {renderGraph()}

                {/* Month Range Filter */}
                <div className={classes.viewInRow}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <DatePicker
                            className={classes.customDatePicker}
                            inputVariant={"outlined"}
                            views={['month', 'year']}
                            value={monthDateRange.startDate}
                            onChange={(a) => {
                                setMonthDateRange({
                                    startDate: new Date(a.getFullYear(), a.getMonth(), 1),
                                    endDate: new Date(a.getFullYear(), a.getMonth() + 1, 0)
                                });
                            }}
                            renderInput={(params) => (
                                <TextField {...params} InputProps={{
                                    endAdornment: 
                                        <InputAdornment position="end">
                                            <InsertInvitationIcon />
                                        </InputAdornment>
                                }} />
                            )}
                        />
                    </MuiPickersUtilsProvider>

                    <Button
                        style={{marginRight: 10}}
                        size="small"
                        color="primary"
                        variant={'contained'}
                        onClick={() => getOOSData()}
                        disabled={loading}>
                        <Typography className={commonStyle.searchBtnFont}>View</Typography>
                        {loading && <CircularProgress size={20}/>}
                    </Button>

                    <Button
                        size="small"
                        color="secondary"
                        variant={'contained'}
                        onClick={() => generateReport()}
                        disabled={loading}>
                        <Typography className={commonStyle.searchBtnFont}>Generate Report</Typography>
                        {loading && <CircularProgress size={20}/>}
                    </Button>
                </div>
            </div>

            {/* Data Tables Container with Horizontal Scroll */}
            <div className={classes.tablesContainer}>
                {renderTable1()}
                {renderTable2()}
                {renderTable3()}
            </div>

            {/* Virtual List Components for Filters */}
            {!gState.company && branchesList.length > 0 && (
                <VirtualListCB
                    open={branchesView}
                    setClose={data => BranchesViewClose(data)}
                    title={"Branch"}
                    data={branchesList}
                    language={language}
                    filteration={0}
                />
            )}

            <VirtualListCB
                open={itemCategoryView}
                setClose={data => ItemCategoryViewClose(data)}
                title={"Item Category"}
                data={itemCategoryList}
                language={language}
                filteration={1}
            />

            <VirtualListCB
                open={outletCategoryView}
                setClose={data => OutletCategoryViewClose(data)}
                title={"Outlet Category"}
                data={outletCategoryList}
                language={language}
                filteration={1}
            />

            <VirtualListCB
                open={outletChainView}
                setClose={data => OutletChainViewClose(data)}
                title={"Outlet Chain"}
                data={outletChainList}
                language={language}
                filteration={1}
            />

            <VirtualListCB
                open={outletTypeView}
                setClose={data => OutletTypeViewClose(data)}
                title={"Outlet Type"}
                data={outletTypeList}
                language={language}
                filteration={1}
            />

            <VirtualListCB
                open={itemView}
                setClose={data => ItemViewClose(data)}
                title={"Item"}
                data={itemList}
                language={language}
                filteration={1}
            />
        </div>
    );
}